<div class="modal">
  <div class="modal-ctn picker">

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.CONTAINER' | translate }}</span>
      <df-input type="search" prefixIcon="heroMagnifyingGlass" allowClear (valueChange)="filterContainers($event)" />
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <div class="containers picker-list">
      @for (container of displayedContainers; track container) {
        <div class="container picker-item">
          <div class="logo">
            @if (hasCompanyLogo(container.transportcompanyName)) {
              <img [src]="getCompanyLogo(container.transportcompanyName)" [alt]="container.transportcompanyName"/>
            } @else {
              <ng-icon name="heroTruck" size="18"/>
            }
            <a>{{ container.transportcompanyName }}</a>
          </div>
          <div class="info">
            <a>{{ container.containerId }}</a>
            <a>{{ 'CONTAINER.CAPACITY' | translate }}: {{ container.containerMaxCapacity }} {{ mission.volumeUom }}</a>
            <a>{{ 'CONTAINER.PRESSURE' | translate }}: {{ container.containerMAWP | number : '1.0-0' }} {{ mission.pressureUom }}</a>
            <a>{{ 'CONTAINER.EMPTY_TARE' | translate }}: {{ container.containerTareWeight | number : '1.0-0' }} {{ mission.weightUom }}</a>
            @if (container.containerPumpCarrier === 1) {
              <a>{{ 'CONTAINER.PUMP_CARRIER' | translate }}</a>
            }
            <a>{{ 'CONTAINER.MODEL_NAME' | translate }}: {{ container.containermodelName }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="addContainer(container)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>